import { Modal, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import Header from './Header';
import {
    SyncOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    FileJpgOutlined,
    AuditOutlined,
  ProfileOutlined
} from "@ant-design/icons";

import KanbanCard from '../../components/KanbanCard';
const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const HeijunkaBoard = () => {
    const [cardData, setCardData] = useState();
    const [cardModal, setCardModal] = useState({
        show: false,
        id: undefined,
        loading: false
    });
    const [responseData, setResponseData] = useState();
    const [configData, setConfigData] = useState();
    const icons = {
        SyncOutlined,
        CloseCircleOutlined,
        ExclamationCircleOutlined,
        SolutionOutlined,
        MobileOutlined,
        ControlOutlined,
        FileJpgOutlined,
        AuditOutlined,
  ProfileOutlined
    }

    const IconComponent = (props) => {
        const Icon = props.icon;
        return Icon ? <Icon {...props} /> : <></>
    }

    useEffect(() => {
        liracrypt.get("/textapi", { dn: "FgHeijunkaBoard1" })
            .then(({ data }) => {
                setResponseData(data.data);
                setConfigData(data.config)
            })
            .catch(err => {
                console.log(err);
            })
    }, []);

    useEffect(() => {
        if (cardModal.show) {
            liracrypt.get("/textapi", { dn: "SingleKanban", _id: cardModal.id })
                .then(({ data }) => {
                    setCardData(data.data);
                    setCardModal({
                        ...cardModal,
                        loading: false
                    })
                })
                .catch(err => {
                    console.error(err);
                })
        }
    }, [cardModal.show]);

    const toggleModal = (args) => {
        let { show, id, loading } = args || {
            show: false,
            id: undefined,
            loading: false
        };
        setCardModal({
            show,
            id,
            loading
        });
    };

    return (
        <div
            className="dash"
            style={{
                backgroundColor: "rgb(29, 29, 29)",
            }}
        >
            <Header />
            {/* <Table columns={columns} dataSource={data} scroll={{ x: 1500, y: 300 }} /> */}
            {
                responseData && (
                    <div className='heizunka-form'>
                        <form className='table-responsive'>
                            <table className='table'>
                                <tr className='time-haizunka'>
                                    <th style={{ position: "sticky", left: "0px", top: "0", zIndex: "2" }}></th>
                                    <th style={{ position: "sticky", left: "118px", top: "0", zIndex: "2" }}></th>
                                    {
                                        responseData?.header.map((x, i) => (
                                            <th key={i} style={{ position: "sticky", top: "0", zIndex: "1" }}>{x.text}</th>
                                        ))
                                    }
                                </tr>
                                <tr>
                                    <th style={{ position: "sticky", left: "0", zIndex: "1"}}>Part No</th>
                                    <th style={{ position: "sticky", left: "118px", zIndex: "1"}}>QTY</th>
                                    {
                                        responseData?.tag.map((tag, tagIndex) => (
                                            <th key={tagIndex}>
                                                {
                                                    tag.map((item, i) => (
                                                        <Tag color={item.bgColTag} key={i} icon={<IconComponent icon={icons[item.icon]} />}>{item.label}</Tag>
                                                    ))
                                                }
                                            </th>
                                        ))
                                    }
                                </tr>
                                {
                                    responseData?.rowData?.map((item, i) => (
                                        <tr>
                                            <th style={{ position: "sticky", left: "0", zIndex: "1"}}>{item.partNo}</th>
                                            <th style={{ position: "sticky", left: "118px", width: "80px", zIndex: "1", backgroundColor: item.bgColQty }}>{item.qty}</th>
                                            {
                                                item?.kanban?.map((kanban, kanbanIndex) => (
                                                    <td key={kanbanIndex} className="custom_box">
                                                        {
                                                            kanban.length &&
                                                            kanban.map((card, cardIndex) => (
                                                                <div>
                                                                    <p style={{cursor: 'pointer'}} onClick={() => toggleModal({
                                                                                show: true,
                                                                                id: card._id,
                                                                                loading: true
                                                                            })} key={cardIndex} className={card.class}>{card.txt1}</p>
                                                                </div>
                                                            ))
                                                        }
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                    ))
                                }

                            </table>
                        </form>
                    </div>

                )
            }

<Modal cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} title="KANBAN CARD" style={{ backgroundColor: cardData?.bgColCard || '' }} className='kanban-modal' open={cardModal.show} onOk={toggleModal} onCancel={toggleModal}>
                {
                    cardModal.loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            {antIcon}
                        </div>
                    ) : (
                        <KanbanCard cardData={cardData} />
                    )
                }
            </Modal>

        </div>
    )
};

export default HeijunkaBoard;